import { SortingArrowButton } from "@exopengithub/exokit";
import type { ComponentPropsWithoutRef, MouseEventHandler } from "react";

interface SortHeaderButtonProps
	// onToggle is a native button attribute (popover ToggleEvent); ours shadows
	// it deliberately, so it has to leave the base type.
	extends Omit<
		ComponentPropsWithoutRef<"button">,
		"children" | "onClick" | "onToggle"
	> {
	label?: string | undefined;
	activeDirection: "asc" | "desc" | null;
	/** Takes the click event so `useSort`'s own column props pass straight through. */
	onToggle: MouseEventHandler<HTMLButtonElement> | undefined;
}

/**
 * Tri-state adapter over ExoKit's header sort button: `activeDirection: null`
 * means this column isn't the sort key, which ExoKit models as `selected={false}`.
 */
export const SortHeaderButton = ({
	label,
	activeDirection,
	onToggle,
	...props
}: SortHeaderButtonProps) => (
	<SortingArrowButton
		variant="header"
		order={activeDirection ?? "asc"}
		selected={activeDirection !== null}
		onClick={onToggle}
		{...props}
	>
		{label}
	</SortingArrowButton>
);
